<rw-modal
  modalId="qboSubscriptionModal"
  datapendoid="qbo-subscription-modal"
  datatestid="qbo-subscription-modal"
  [title]="getTitle()"
  [arialabel]="'qbo subscription'"
  [dismissible]="false"
  size="lg"
  #modalRef
>
  <div modal-body> 
      @if (formIsLoading) {
        <div class="loadingMargin"></div>
          <app-loader text="Loading..."></app-loader>
      }
      @else {
                <div class="completeMargin"></div>
      <div class="firstLine"></div>
        <div
          [ngClass]="{
            greyLine: formSteps.activeIndex === 0,
            blueLine: formSteps.activeIndex === 1,
            blueLine1: formSteps.activeIndex === 2,
            blueLine2: formSteps.activeIndex === 3,
            blueLine3: formSteps.activeIndex === 4
          }"
        ></div>
        <div
          [ngClass]="{
            greyLine: formSteps.activeIndex === 0,
            greyLine1: formSteps.activeIndex === 1,
            blueLine1: formSteps.activeIndex === 2,
            blueLine2: formSteps.activeIndex === 3,
            blueLine3: formSteps.activeIndex === 4
          }"
        ></div>
        <div
          [ngClass]="{
            greyLine: formSteps.activeIndex === 0,
            greyLine1: formSteps.activeIndex === 1,
            greyLine2: formSteps.activeIndex === 2,
            blueLine2: formSteps.activeIndex === 3,
            blueLine3: formSteps.activeIndex === 4
          }"
        ></div>
        <div class="m-b-10 qbo-desc">
          <span class="step-desc qbo-step-desc" [innerHtml]="formSteps.getActiveStep().desc"></span>
        </div>
        <form [formGroup]="mainForm">
          @switch (formSteps.getActiveStep().ID) {
            @case ('QboPlans') {
              <app-qbo-plans
                [plansForm]="mainForm.get('QboPlans')"
                (QboPlansSelected)="qboPlanSelected($event)"
                [qboPlansData]="QboPlansData"
                [qboExistingPlan]="existingItem"
                [isChangeSub]="isChangeSubscription"
              ></app-qbo-plans>
            }
            @case ('QboPayroll') {
              <app-qbo-payroll
                [payrollForm]="mainForm.get('QboPayroll')"
                (QboPayrollSelected)="qboPayrollSelected($event)"
                [qboPayrollData]="QboPayrollData"
                [qboExistingPlan]="existingItem"
                [isChangeSub]="isChangeSubscription"
              ></app-qbo-payroll>
            }
            @case ('QboTime') {
              <app-qbo-time
                [timeForm]="mainForm.get('QboTime')"
                (QboTimeSelected)="qboTimeSelected($event)"
                [qboTimeData]="QboTimeData"
                [qboExistingPlan]="existingItem"
                [isChangeSub]="isChangeSubscription"
              ></app-qbo-time>
            }
            @case ('QboCheckout') {
              <app-qbo-checkout
                [checkoutForm]="mainForm.get('QboCheckout')"
                [qboCheckout]="checkoutData"
              ></app-qbo-checkout>
            }
            @case ('QboConfirmation') {
              <app-qbo-confirmation
                [confirmationForm]="mainForm.get('QboConfirmation')"
                [qboCheckout]="checkoutData"
              ></app-qbo-confirmation>
            }
          }
          </form>
      }
      
  </div>
  <div modal-footer>
    @if (hasBeenInitialized){
      <div>
        <app-button
          id="btnCancel"
          label="CANCEL"
          buttonStyle="addUserTeritary"
          noContentPadding="true"
          (clickActionEmitter)="close()"
        >
        </app-button>
        <app-button
          id="btnPrevious"
          label="BACK"
          [disabled] = "!backEnabled()"
          buttonStyle="addUserTeritary"
          noContentPadding="true"
          (clickActionEmitter)="handlePrevious()"
        >
        </app-button>
        <app-button
          id="btnNext"
          [label]="formSteps.getActiveStep().btnText"
          buttonStyle="primary"
          [processing]="processing()"
          [disabled] = "!isNextEnabled()"
          showProcessing="true"
          noContentPadding="true"
          (clickActionEmitter)="handleNext()"
        >
        </app-button>
      </div>
    }
  </div>
</rw-modal>
